import { ReactElement } from 'react';
import MaterialImage from '../../../../components/material-image/material-image';
import handleLinkClick from '../../../../utils/handle-link-click';
import './left-aside.scss';

type LeftAsideProps = { item: Material; link: string; index: number; internalPath?: string };

const LeftAside = ({ item, link, index, internalPath }: LeftAsideProps): ReactElement => {
    const handleImageClick = (): void => handleLinkClick({ item, index });

    return (
        <aside className='left-aside'>
            <MaterialImage
                item={item}
                link={link}
                imageSize='long-mobile'
                onClick={handleImageClick}
                index={index}
                internalPath={internalPath}
            />
        </aside>
    );
};

export default LeftAside;
